import { render, staticRenderFns } from "./ChatPanel.vue?vue&type=template&id=4ed5cdbf&"
import script from "./ChatPanel.vue?vue&type=script&lang=ts&"
export * from "./ChatPanel.vue?vue&type=script&lang=ts&"
import style0 from "./ChatPanel.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports